export default "__VITE_ASSET__0buUFojf__"